/**
 * 当前用户账户（mock，P-D 用户信息面板）。
 *
 * 接真后端时对接旧项目 users/license/token：积分以内部值存储，UI 一律用「电量式百分比」
 * 呈现（见 creditGauge），不暴露绝对积分数（避免跨软件比价）。此处仅提供面板所需种子数据。
 */
import { creditGauge, type CreditGauge } from './credit';

export type Plan = 'free' | 'member' | 'studio' | 'enterprise';

export interface UserAccount {
  name: string;
  uuid: string;
  accessKey: string;
  plan: Plan;
  /** 内部积分（UI 只显示百分比） */
  credits: { total: number; bonus: number; used: number };
  storage: { usedGB: number; totalGB: number };
  notifications: number;
  workspaces: { id: string; name: string }[];
}

export const PLAN_LABEL: Record<Plan, string> = {
  free: '免费用户',
  member: '会员',
  studio: '工作室版',
  enterprise: '企业版',
};

export const MOCK_USER: UserAccount = {
  name: '创作者 12c9b7',
  uuid: 'a6f01c29-0000-4000-8000-videoai',
  accessKey: 'ak-xxxxxxxxxxxx-****',
  plan: 'free',
  credits: { total: 2980, bonus: 298, used: 0 },
  storage: { usedGB: 0, totalGB: 3 },
  notifications: 2,
  workspaces: [{ id: 'ws-1', name: '默认工作室' }],
};

/** 用户额度百分比（电量式）。 */
export function userCreditGauge(u: UserAccount): CreditGauge {
  return creditGauge(u.credits.total, u.credits.bonus, u.credits.used);
}
